<template>
  <div class="share">
    <new-head class="pos-top" title="分享"> </new-head>
    <div class="invitation">转发任务，分享奖金</div>
    <div class="explain">
      邀请新人每次完成任务，邀请人都将获得改任务总奖金的5%作为佣金
    </div>
    <div class="main">
      <img :src="basse" alt="" />
      <div class="tip">扫描二维码下载应用</div>
      <div class="btn">长按保存图片并在微信或朋友圈分享</div>
    </div>
  </div>
</template>

<script>
import { createCode } from "@/api/api/wechat";
export default {
  data() {
    return {
      basse: "",
    };
  },

  created() {
    this.QRcode();
  },
  methods: {
    QRcode() {
      if (this.$route.query.task_id) {
        createCode("/#/get", this.$route.query.task_id).then((res) => {
          //console.log(res)
          this.basse = res.data.data.imgContent;
        });
      } else {
        createCode("/#/login").then((res) => {
          //console.log(res)
          this.basse = res.data.data.imgContent;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share {
  min-height: 100%;
  padding: 0 30px;
  padding-top: calc(45px + 44px);
  .invitation {
    height: 35px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
    color: #0286ff;
  }
  .explain {
    margin-top: 11px;
    height: 46px;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #333333;
    text-align: center;
  }
  .main {
    height: 428px;
    background: #ffffff;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.12);
    opacity: 1;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > img {
      width: 220px;
      height: 220px;
    }
    .tip {
      font-size: 13px;
      color: #a0a0a0;
      margin-top: 22px;
    }
    .btn {
      width: 268px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #0286ff;
      opacity: 1;
      font-size: 13px;
      color: #ffffff;
      margin-top: 53px;
    }
  }
  
}
</style>